/*
 * 画像パララックス（transformベース・モバイル可）
 * 使い方: コンテナ（overflow:hidden）に data-parallax="0.12" を付与し、中に <img> を入れる。
 *         img はコンテナより縦に大きく（例 height:130%; top:-15%）しておくこと。
 *  data-parallax の値 = コンテナ高さに対する片側移動量の割合（既定 0.12）
 */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  var items = [];
  var ticking = false;

  function update() {
    ticking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;

    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var rect = it.wrap.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) continue; // 画面外はスキップ

      // 0（コンテナが画面下から入る直前）〜 1（画面上へ抜ける）
      var progress = (vh - rect.top) / (vh + rect.height);
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;

      var offsetMax = rect.height * it.amount;
      var offset = (0.5 - progress) * offsetMax * 2;
      it.img.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  function init(root) {
    var scope = root || document;
    var wraps = scope.querySelectorAll('[data-parallax]:not([data-parallax-init])');
    Array.prototype.forEach.call(wraps, function (wrap) {
      var img = wrap.querySelector('img');
      if (!img) return;
      wrap.setAttribute('data-parallax-init', '');
      var amount = parseFloat(wrap.getAttribute('data-parallax'));
      if (isNaN(amount)) amount = 0.12;
      items.push({ wrap: wrap, img: img, amount: amount });
    });
    if (items.length) update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
